<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="wt-tab-info-card">
        <div class="wt-tab-info-title">基本信息</div>
        <div class="wt-tab-info-content wt-tab-base">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">社区名称：</span>
            <span class="wt-tab-base-value">{{ detailFormData.communityName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">站点名称：</span>
            <span class="wt-tab-base-value">{{ detailFormData.name }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">站点位置：</span>
            <span class="wt-tab-base-value">{{ detailFormData.address }}</span>
          </div>
        </div>
      </div>
      <div class="wt-tab-info-card">
        <el-tabs v-model="activeTabName" type="card">
          <el-tab-pane label="可回收投递物" name="1"></el-tab-pane>
          <el-tab-pane label="商品补货" name="2"></el-tab-pane>
          <el-tab-pane label="兑换记录" name="3"></el-tab-pane>
          <el-tab-pane label="出库记录" name="4"></el-tab-pane>
          <el-tab-pane label="其他类型记录" name="5"></el-tab-pane>
          <el-tab-pane label="耗材补货" name="6"></el-tab-pane>
        </el-tabs>
        <SiteDeliveryView v-if="activeTabName === '1'" :hideBtn="true"></SiteDeliveryView>
        <SiteGoodsViewTab v-if="activeTabName === '2'"></SiteGoodsViewTab>
        <SiteGoodsExchangeViewTab v-if="activeTabName === '3'"></SiteGoodsExchangeViewTab>
        <SiteOutboundViewTab v-if="activeTabName === '4'"></SiteOutboundViewTab>
        <SiteConsumablesViewTab v-if="activeTabName === '6'"></SiteConsumablesViewTab>
        <SiteOtherDeliveryViewTab v-if="activeTabName === '5'"></SiteOtherDeliveryViewTab>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserAreaSiteViewPage',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      activeTabName: '1',
      detailFormButtons: {
        title: '区域负责人详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      }
    }
  },
  created() {
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      }
    },
    onButtonAction() {}
  },
  computed: {
    ...mapState({
      detailFormData: state => state.siteManage.siteDetailData
    })
  }
}
</script>

<style scoped>
.action-check-group {
  padding-left: 180px;
}
.action-check-group .el-checkbox {
  margin-bottom: 8px;
}
</style>
